import { Component } from '@angular/core';
import {GlobalErrorHandler} from "../../global-error-handler";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-show-errors',
  templateUrl: './show-errors.component.html',
  styleUrl: './show-errors.component.scss'
})
export class ShowErrorsComponent {

  displayedColumns = ['time','message','stack'];

  get errors() {
    return GlobalErrorHandler.getErrors();
  }

  protected readonly JSON = JSON;

  clear() {
    GlobalErrorHandler.clearErrors();
  }
}
